import React, { useState } from 'react';
import Dropdown from 'app/components/Dropdown';
import NewUserReport from './Reports/NewUserReport';
import OverAllDataReport from './Reports/OverAllDataReport';
import OverAllPointsReport from './Reports/OverAllPointsReport';
import VoucherClaimedDataReport from './Reports/VoucherClaimedDataReport';
import LiabilityReport from './Reports/LiabilityReport';
import SlabUpdateReport from './Reports/SlabUpdateReport';
import RedemptionReport from './Reports/RedemptionReport';
import GraphAnalylitics from './GraphAnalylitics';
import SlabBifurcationReport from './Reports/SlabBifuractionReport';

const ReportsManagement = () => {
  const [selectedReport, setSelectedReport] = useState('');
  function handleSelect(e) {
    setSelectedReport(e.target.value);
  }
  const report_type = [
    {
      value: 'no-report',
      label: 'Select report',
    },
    {
      value: 'overall_data',
      label: 'Over all Accepted bills Data Report',
    },
    { value: 'new_user_database', label: 'New User Data Report' },
    { value: 'voucher_claimed', label: 'Voucher claimed Report' },
    { value: 'over_all_points_database', label: 'Total User Data Report' },
    { value: 'liability_data', label: 'Liability Data Report' },
    { value: 'redemption_data', label: 'Redemption Data Report' },
    { value: 'slab_bifurcation_report', label: 'Slab Bifurcation Report' },
  ];

  const renderReportComponent = () => {
    switch (selectedReport) {
      case 'overall_data':
        return <OverAllDataReport />;
      case 'new_user_database':
        return <NewUserReport />;
      case 'voucher_claimed':
        return <VoucherClaimedDataReport />;
      case 'over_all_points_database':
        return <OverAllPointsReport />;
      case 'liability_data':
        return <LiabilityReport />;
      case 'slab_update_data':
        return <SlabUpdateReport />;
      case 'redemption_data':
        return <RedemptionReport />;
      case 'slab_bifurcation_report':
        return <SlabBifurcationReport />;
      case 'no-report':
        return <GraphAnalylitics />;
      default:
        return <GraphAnalylitics />;
    }
  };

  return (
    <>
      <div className='cms-content__container'>
        <h4>Reports</h4>
        <div>
          <div>
            <Dropdown
              label='Report Type*'
              options={report_type}
              value={selectedReport}
              placeholder='Select Report '
              handleChange={handleSelect}
            />
          </div>
          <div>{renderReportComponent()}</div>
        </div>
      </div>
    </>
  );
};

export default ReportsManagement;
